export const GLINT_REVEAL_CONFIG_KEY = 'glintRevealDurations'

export interface GlintDurationConfig {
  glintDuration: number
  fadeDuration: number
  experienceDuration: number
}

export const DEFAULT_GLINT_DURATION = 5.2
export const DEFAULT_FADE_DURATION = 0.6
export const DEFAULT_EXPERIENCE_DURATION = 2.5

export const DEFAULT_GLINT_DURATION_CONFIG: GlintDurationConfig = {
  glintDuration: DEFAULT_GLINT_DURATION,
  fadeDuration: DEFAULT_FADE_DURATION,
  experienceDuration: DEFAULT_EXPERIENCE_DURATION
}

const sanitizeDuration = (value: unknown, fallback: number) => {
  if (typeof value !== 'number' || Number.isNaN(value) || !Number.isFinite(value)) return fallback
  return Math.max(0, value)
}

export const loadGlintDurationConfig = (): GlintDurationConfig => {
  if (typeof window === 'undefined') {
    return DEFAULT_GLINT_DURATION_CONFIG
  }

  try {
    const raw = window.localStorage.getItem(GLINT_REVEAL_CONFIG_KEY)
    if (!raw) return DEFAULT_GLINT_DURATION_CONFIG
    const parsed = JSON.parse(raw) as Partial<GlintDurationConfig>

    return {
      glintDuration: sanitizeDuration(parsed.glintDuration, DEFAULT_GLINT_DURATION),
      fadeDuration: sanitizeDuration(parsed.fadeDuration, DEFAULT_FADE_DURATION),
      experienceDuration: sanitizeDuration(parsed.experienceDuration, DEFAULT_EXPERIENCE_DURATION)
    }
  } catch (error) {
    return DEFAULT_GLINT_DURATION_CONFIG
  }
}

export const persistGlintDurationConfig = (config: GlintDurationConfig) => {
  if (typeof window === 'undefined') return

  const sanitized = {
    glintDuration: sanitizeDuration(config.glintDuration, DEFAULT_GLINT_DURATION),
    fadeDuration: sanitizeDuration(config.fadeDuration, DEFAULT_FADE_DURATION),
    experienceDuration: sanitizeDuration(config.experienceDuration, DEFAULT_EXPERIENCE_DURATION)
  }

  window.localStorage.setItem(GLINT_REVEAL_CONFIG_KEY, JSON.stringify(sanitized))
}
